<template>
  <v-card class="shadowCard">
    <v-card-title class="text-subtitle-1">
      Bono de fin de semana
      <span class="ml-2 grey--text text-body-2" v-if="rangoTexto">{{ rangoTexto }}</span>
      <v-spacer></v-spacer>
      <v-select
        v-model="filtroEscuela"
        :items="opcionesEscuela"
        dense
        filled
        hide-details
        class="filtro-escuela"
        style="max-width: 180px;"
      />
    </v-card-title>
    <v-card-text>
      <div class="mb-2 grey--text text-caption">
        El bono se gana con el <b>total</b> de liquidados (lunes a domingo), no por día. Solo cuenta NI del <b>ciclo 08</b> (primera inscripción). No cuenta RI, niveles anteriores ni otros ciclos.
        Meta total se calcula sola. El monto del bono se captura a mano.
      </div>
      <div class="mb-3 text-caption">
        <span :class="dobleInbi ? 'green--text text--darken-2 font-weight-medium' : 'grey--text'">
          INBI ×2 si llega a {{ META_DOBLE_INBI }} inscritos del ciclo (van {{ mostrarNum(totalInbi) }}){{ dobleInbi ? ' — activo' : '' }}
        </span>
        <span class="mx-2 grey--text">·</span>
        <span :class="dobleFast ? 'green--text text--darken-2 font-weight-medium' : 'grey--text'">
          FAST ×2 si llega a {{ META_DOBLE_FAST }} inscritos del ciclo (van {{ mostrarNum(totalFast) }}){{ dobleFast ? ' — activo' : '' }}
        </span>
      </div>
      <v-data-table
        :headers="headers"
        :items="filtradas"
        :loading="cargando"
        class="elevation-0"
        dense
        item-key="id_usuario"
        :items-per-page="filtradas.length || 10"
        hide-default-footer
        mobile-breakpoint="200"
      >
        <template v-slot:item.escuela="{ item }">
          {{ item.escuela === 2 ? 'FAST' : 'INBI' }}
        </template>

        <template v-slot:item.meta_lunes="{ item }">
          <v-text-field
            v-if="puedeEditar"
            :value="item.meta_lunes"
            type="number"
            dense
            filled
            hide-details
            min="0"
            @blur="guardarMeta(item, 'meta_lunes', $event)"
          />
          <span v-else>{{ mostrarNum(item.meta_lunes) }}</span>
        </template>

        <template v-slot:item.meta_martes="{ item }">
          <v-text-field
            v-if="puedeEditar"
            :value="item.meta_martes"
            type="number"
            dense
            filled
            hide-details
            min="0"
            @blur="guardarMeta(item, 'meta_martes', $event)"
          />
          <span v-else>{{ mostrarNum(item.meta_martes) }}</span>
        </template>

        <template v-slot:item.meta_miercoles="{ item }">
          <v-text-field
            v-if="puedeEditar"
            :value="item.meta_miercoles"
            type="number"
            dense
            filled
            hide-details
            min="0"
            @blur="guardarMeta(item, 'meta_miercoles', $event)"
          />
          <span v-else>{{ mostrarNum(item.meta_miercoles) }}</span>
        </template>

        <template v-slot:item.meta_jueves="{ item }">
          <v-text-field
            v-if="puedeEditar"
            :value="item.meta_jueves"
            type="number"
            dense
            filled
            hide-details
            min="0"
            @blur="guardarMeta(item, 'meta_jueves', $event)"
          />
          <span v-else>{{ mostrarNum(item.meta_jueves) }}</span>
        </template>

        <template v-slot:item.meta_viernes="{ item }">
          <v-text-field
            v-if="puedeEditar"
            :value="item.meta_viernes"
            type="number"
            dense
            filled
            hide-details
            min="0"
            @blur="guardarMeta(item, 'meta_viernes', $event)"
          />
          <span v-else>{{ mostrarNum(item.meta_viernes) }}</span>
        </template>

        <template v-slot:item.meta_sabado="{ item }">
          <v-text-field
            v-if="puedeEditar"
            :value="item.meta_sabado"
            type="number"
            dense
            filled
            hide-details
            min="0"
            @blur="guardarMeta(item, 'meta_sabado', $event)"
          />
          <span v-else>{{ mostrarNum(item.meta_sabado) }}</span>
        </template>

        <template v-slot:item.meta_domingo="{ item }">
          <v-text-field
            v-if="puedeEditar"
            :value="item.meta_domingo"
            type="number"
            dense
            filled
            hide-details
            min="0"
            @blur="guardarMeta(item, 'meta_domingo', $event)"
          />
          <span v-else>{{ mostrarNum(item.meta_domingo) }}</span>
        </template>

        <template v-slot:item.meta_total="{ item }">
          <b>{{ mostrarNum(item.meta_total) }}</b>
        </template>

        <template v-slot:item.bono_monto="{ item }">
          <div>
            <v-text-field
              v-if="puedeEditar"
              :value="item.bono_monto"
              type="number"
              dense
              filled
              hide-details
              min="0"
              prefix="$"
              @blur="guardarMeta(item, 'bono_monto', $event)"
            />
            <span v-else>{{ formatMoney(item.bono_monto) }}</span>
            <div v-if="escuelaConDoble(item.escuela) && Number(item.bono_monto) > 0" class="caption green--text text--darken-2 font-weight-medium mt-1">
              × 2 = {{ formatMoney(bonoResultado(item)) }}
            </div>
          </div>
        </template>

        <template v-slot:item.inscritos="{ item }">
          <v-chip
            small
            class="chip-liquidados"
            :color="item.alcanzado ? 'green' : (item.inscritos > 0 ? 'indigo' : 'grey')"
            text-color="white"
            @click="abrirLista(item, 'liquidados')"
          >
            {{ item.inscritos || 0 }}
          </v-chip>
        </template>

        <template v-slot:item.validados="{ item }">
          <v-chip
            small
            class="chip-liquidados"
            :color="colorValidados(item)"
            text-color="white"
            @click="abrirLista(item, 'validados')"
          >
            {{ item.validados || 0 }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="dialogLiquidados" max-width="980">
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold">
          {{ tituloDialog }} — {{ vendedoraSeleccion }}
          <v-spacer />
          <v-btn icon small @click="dialogLiquidados = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersLiquidados"
            :items="alumnosSeleccion"
            item-key="id"
            dense
            elevation-0
            :items-per-page="25"
            mobile-breakpoint="0"
            :no-data-text="textoVacioDialog"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import validarErrores from '@/mixins/validarErrores'
import Alerta from '@/components/alertas/Alerta.vue'

const IDERPS_EDITAN = [1, 334, 568]
const CAMPOS_META_DIA = [
  'meta_lunes',
  'meta_martes',
  'meta_miercoles',
  'meta_jueves',
  'meta_viernes',
  'meta_sabado',
  'meta_domingo',
]
const META_DOBLE_INBI = 1000
const META_DOBLE_FAST = 300

export default {
  name: 'TablaBonoVendedoras',

  mixins: [validarErrores],

  components: { Alerta },

  props: {
    totalInbi: { type: Number, default: 0 },
    totalFast: { type: Number, default: 0 },
  },

  data() {
    return {
      META_DOBLE_INBI,
      META_DOBLE_FAST,
      filtroEscuela: 0,
      opcionesEscuela: [
        { text: 'Todas', value: 0 },
        { text: 'INBI', value: 1 },
        { text: 'FAST', value: 2 },
      ],
      vendedoras: [],
      fechas: null,
      cargando: true,
      dialogLiquidados: false,
      tituloDialog: 'Liquidados',
      vendedoraSeleccion: '',
      alumnosSeleccion: [],
      headers: [
        { text: 'Vendedora', value: 'nombre_completo' },
        { text: 'Escuela', value: 'escuela', width: 80 },
        { text: 'Meta lunes', value: 'meta_lunes', width: 96 },
        { text: 'Meta martes', value: 'meta_martes', width: 96 },
        { text: 'Meta miércoles', value: 'meta_miercoles', width: 110 },
        { text: 'Meta jueves', value: 'meta_jueves', width: 96 },
        { text: 'Meta viernes', value: 'meta_viernes', width: 96 },
        { text: 'Meta sábado', value: 'meta_sabado', width: 96 },
        { text: 'Meta domingo', value: 'meta_domingo', width: 110 },
        { text: 'Meta total', value: 'meta_total', width: 96 },
        { text: 'Bono', value: 'bono_monto', width: 150 },
        { text: 'Liquidados', value: 'inscritos', width: 100 },
        { text: 'Validados', value: 'validados', width: 100 },
      ],
    }
  },

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    puedeEditar() {
      const id = Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp)
      return IDERPS_EDITAN.includes(id)
    },
    filtradas() {
      if (!this.filtroEscuela) return this.vendedoras
      return this.vendedoras.filter((v) => Number(v.escuela) === Number(this.filtroEscuela))
    },
    rangoTexto() {
      if (!this.fechas) return ''
      const ini = this.fechas.inicio || this.fechas.lunes
      const fin = this.fechas.fin || this.fechas.domingo
      return ini && fin ? `(${ini} → ${fin})` : ''
    },
    dobleInbi() {
      return Number(this.totalInbi) >= META_DOBLE_INBI
    },
    dobleFast() {
      return Number(this.totalFast) >= META_DOBLE_FAST
    },
    textoVacioDialog() {
      if (this.tituloDialog === 'Validados') return 'Esta vendedora no tiene validados esta semana'
      return 'Esta vendedora no tiene liquidados esta semana'
    },
    headersLiquidados() {
      return [
        { text: 'Alumno', value: 'alumno' },
        { text: 'Matrícula', value: 'matricula', width: 120 },
        { text: 'Día', value: 'dia', width: 110 },
        { text: 'Primer pago', value: 'primer_pago', width: 130 },
        { text: 'Fecha liquidación', value: 'fecha', width: 140 },
        { text: 'Grupo', value: 'grupo' },
      ]
    },
  },

  created() {
    this.cargarMetas()
  },

  methods: {
    mostrarNum(valor) {
      if (valor === null || valor === undefined || valor === '') return '—'
      return valor
    },
    formatMoney(valor) {
      const n = Number(valor)
      if (!Number.isFinite(n)) return '—'
      return n.toLocaleString('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 })
    },
    escuelaConDoble(escuela) {
      return Number(escuela) === 2 ? this.dobleFast : this.dobleInbi
    },
    bonoResultado(item) {
      const base = Number(item && item.bono_monto) || 0
      return this.escuelaConDoble(item && item.escuela) ? base * 2 : base
    },
    colorValidados(item) {
      const n = Number(item.validados) || 0
      const inscritos = Number(item.inscritos) || 0
      if (n > 0 && inscritos > 0 && n >= inscritos) return 'green'
      if (n > 0) return 'teal'
      return 'grey'
    },
    cargarMetas() {
      this.cargando = true
      return this.$http.get('kpi.bono.finde.vendedoras').then((response) => {
        const data = (response && response.data) || {}
        this.vendedoras = data.vendedoras || []
        this.fechas = data.fechas || null
        this.cargarInscritos()
      }).catch((error) => {
        const msg = error && error.response && error.response.data && error.response.data.message
        this.validarError(msg || 'No se pudieron cargar las metas de bono')
      }).finally(() => {
        this.cargando = false
      })
    },
    mapAlumnos(lista) {
      return (Array.isArray(lista) ? lista : []).map((el, i) => ({
        ...el,
        id: `${el.id_alumno || i}-${el.id_grupo || 0}-${i}`,
      }))
    },
    cargarInscritos() {
      return this.$http.post('kpi.bono.finde.inscritos', {}).then((response) => {
        const lista = (response && response.data && response.data.inscritos) || []
        const map = {}
        lista.forEach((row) => {
          map[`${Number(row.id_usuario)}_${Number(row.escuela)}`] = row
        })
        this.vendedoras = this.vendedoras.map((v) => {
          const row = map[`${Number(v.id_usuario)}_${Number(v.escuela)}`]
          if (!row) return { ...v, validados: 0, alumnos_validados: [] }
          const inscritos = Number(row.inscritos) || 0
          const validados = Number(row.validados) || 0
          return {
            ...v,
            inscritos,
            validados,
            inscritos_lunes: Number(row.lunes) || 0,
            inscritos_martes: Number(row.martes) || 0,
            inscritos_miercoles: Number(row.miercoles) || 0,
            inscritos_jueves: Number(row.jueves) || 0,
            inscritos_viernes: Number(row.viernes) || 0,
            inscritos_sabado: Number(row.sabado) || 0,
            inscritos_domingo: Number(row.domingo) || 0,
            alcanzado: v.meta_total > 0 && inscritos >= v.meta_total,
            alumnos: this.mapAlumnos(row.alumnos),
            alumnos_validados: this.mapAlumnos(row.alumnos_validados),
          }
        })
      }).catch(() => {})
    },
    abrirLista(item, tipo) {
      this.vendedoraSeleccion = (item && item.nombre_completo) || 'Vendedora'
      if (tipo === 'validados') {
        this.tituloDialog = 'Validados'
        this.alumnosSeleccion = (item && item.alumnos_validados) || []
      } else {
        this.tituloDialog = 'Liquidados'
        this.alumnosSeleccion = (item && item.alumnos) || []
      }
      this.dialogLiquidados = true
    },
    valorInput(event) {
      const raw = event && event.target ? event.target.value : event
      if (raw === '' || raw == null) return null
      const n = Number(raw)
      return Number.isFinite(n) ? n : null
    },
    guardarMeta(item, campo, event) {
      item[campo] = this.valorInput(event)
      if (campo !== 'bono_monto') {
        const vals = CAMPOS_META_DIA.map((key) => item[key])
        const hay = vals.some((v) => v != null)
        item.meta_total = hay ? vals.reduce((acc, v) => acc + (Number(v) || 0), 0) : null
      }
      this.persistir(item)
    },
    persistir(item) {
      const payload = {
        id_usuario: item.id_usuario,
        nombre_completo: item.nombre_completo,
        escuela: item.escuela,
        meta_lunes: item.meta_lunes,
        meta_martes: item.meta_martes,
        meta_miercoles: item.meta_miercoles,
        meta_jueves: item.meta_jueves,
        meta_viernes: item.meta_viernes,
        meta_sabado: item.meta_sabado,
        meta_domingo: item.meta_domingo,
        bono_monto: item.bono_monto,
      }
      return this.$http.post('kpi.bono.finde.vendedora', payload).then((response) => {
        const data = (response && response.data) || {}
        if (data.meta_total != null) item.meta_total = data.meta_total
      }).catch((error) => {
        const msg = error && error.response && error.response.data && error.response.data.message
        this.validarError(msg || 'No se pudo guardar la meta')
      })
    },
  },
}
</script>

<style scoped>
.filtro-escuela {
  font-size: 13px;
}

.chip-liquidados {
  cursor: pointer;
}
</style>
